import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadPageContent, handlePageLinkClick } from '../utils/pageHelpers';
import { PageSkeleton } from '../components/Loading';

interface CustomerPageProps {
  subpage?: string;
}

const CustomerPage: React.FC<CustomerPageProps> = ({ subpage = 'cs1' }) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const contentRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        const url = (subpage === 'variousform' || subpage === 'qna' || subpage === 'communication')
          ? `/cloneTarget/www.keso.kr/${subpage}.html`
          : `/cloneTarget/www.keso.kr/cs/${subpage}.html`;

        const fullContent = await loadPageContent(url);
        setContent(fullContent);
      } catch (error) {
        console.error('Error loading content:', error);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [subpage]);

  useEffect(() => {
    if (!contentRef.current) return;

    const contentElement = contentRef.current;
    const linkClickHandler = (e: Event) => handlePageLinkClick(e, navigate);

    contentElement.addEventListener('click', linkClickHandler, true);
    window.scrollTo(0, 0);

    return () => {
      contentElement.removeEventListener('click', linkClickHandler, true);
    };
  }, [content, navigate]);

  if (loading) {
    return <PageSkeleton />;
  }

  return (
    <div ref={contentRef} dangerouslySetInnerHTML={{ __html: content }} />
  );
};

export default CustomerPage;
